/**
 * Ритм ожидания асинхронной задачи модуля.
 *
 * Опрос шёл раз в секунду и обрывался на трёхсотой попытке. Обе величины
 * оказались неудачными.
 *
 * Шаг: проверка розыска МВД занимает полторы-две минуты, и за неё страница
 * отправляла под полторы сотни запросов статуса — притом что первые секунды
 * задача просто стоит в очереди. Частый опрос нужен только вначале, когда
 * модуль может ответить сразу из базы.
 *
 * Предел: он совпадал со сроком самого долгого модуля (300 с у розыска МВД).
 * Задача при этом сперва ждёт очереди — источник МВД пускает по одной
 * проверке за раз, — поэтому её собственные пять минут начинаются позже, и
 * страница успевала сказать «таймаут» по живой задаче. Ждём по часам, с
 * запасом на очередь.
 */

/** Полный бюджет ожидания результата, миллисекунды. */
export const TASK_POLL_DEADLINE_MS = 900_000;

/** Пауза перед следующим опросом по номеру уже сделанной попытки (с нуля). */
export const taskPollDelayMs = (attempt: number): number => {
  if (attempt < 10) return 1000;
  if (attempt < 40) return 2000;
  return 5000;
};
